import React from 'react';
import { ConfigValuesContext, ConfigValuesContextData } from './ConfigValuesProvider';

export const useConfigValuesContext = (): ConfigValuesContextData => {
  const cookieContext = React.useContext(ConfigValuesContext);

  if (!cookieContext) {
    throw new Error('useConfigValuesContext must be used within a ConfigValuesProvider');
  }

  return cookieContext;
};
